import { GetAllRevisionsQuery } from '../__generated__/graphql';
import { Unpacked } from '../graphQLTypes/types';

export type Revision = NonNullable<Unpacked<GetAllRevisionsQuery['revisions']>>;

export function newestAssessment(revision: Revision) {
  return revision.projectLeadAssessments?.find((x) => !!x) ?? null;
}
